module.exports = __webpack_public_path__ + "img/head.9c27fdf1.png";